import React from 'react'
import Navbar from '../components/Navbar'
import Faq from '../components/Faq'
import Footer from '../components/Footer'



const Faqpage = () => {
  return (
    <div className='bg-[#333]'>
      <Navbar/>
      <Faq/>
      <Footer/>
    </div>
  )
}

export default Faqpage
